export default {
  pt: {
    'portal.minhasCargasPage.load': 'Carga',
    'portal.minhasCargasPage.contract': 'Contrato',
    'portal.minhasCargasPage.destination': 'Destino',
    'portal.minhasCargasPage.date': 'Data',
    'portal.minhasCargasPage.start': 'Início',
    'portal.minhasCargasPage.estimatedArrival': 'Previsão chegada',
    'portal.minhasCargasPage.progress': 'Andamento',
    'portal.minhasCargasPage.title': 'Minhas cargas',
    'portal.minhasCargasPage.eyebrow': 'Portal do cliente',
    'portal.minhasCargasPage.subtitle': 'Acompanhe o andamento de cada carga da sua operação.',
    'portal.minhasCargasPage.list': 'Lista',
    'portal.minhasCargasPage.loadFailed': 'Não foi possível carregar.',
    'portal.minhasCargasPage.empty': 'Nenhuma carga ainda. Suas cargas aparecem quando você envia uma solicitação.',
    'portal.minhasCargasPage.kanban': 'Kanban',
    'portal.minhasCargasPage.status.draft': 'Rascunho',
    'portal.minhasCargasPage.status.awaiting_harvest': 'Aguardando colheita',
    'portal.minhasCargasPage.status.loading': 'Carregando',
    'portal.minhasCargasPage.status.awaiting_invoice': 'Aguardando nota fiscal',
    'portal.minhasCargasPage.status.awaiting_unload': 'Aguardando descarga',
    'portal.minhasCargasPage.status.unloading': 'Em descarga',
    'portal.minhasCargasPage.status.released': 'Liberada',
    'portal.minhasCargasPage.status.cancelled': 'Cancelada',
  },
  en: {
    'portal.minhasCargasPage.load': 'Load',
    'portal.minhasCargasPage.contract': 'Contract',
    'portal.minhasCargasPage.destination': 'Destination',
    'portal.minhasCargasPage.date': 'Date',
    'portal.minhasCargasPage.start': 'Start',
    'portal.minhasCargasPage.estimatedArrival': 'Estimated arrival',
    'portal.minhasCargasPage.progress': 'Progress',
    'portal.minhasCargasPage.title': 'My loads',
    'portal.minhasCargasPage.eyebrow': 'Customer portal',
    'portal.minhasCargasPage.subtitle': 'Track the progress of each load in your operation.',
    'portal.minhasCargasPage.list': 'List',
    'portal.minhasCargasPage.loadFailed': 'Could not load.',
    'portal.minhasCargasPage.empty': 'No loads yet. Your loads appear when you submit a request.',
    'portal.minhasCargasPage.kanban': 'Kanban',
    'portal.minhasCargasPage.status.draft': 'Draft',
    'portal.minhasCargasPage.status.awaiting_harvest': 'Awaiting harvest',
    'portal.minhasCargasPage.status.loading': 'Loading',
    'portal.minhasCargasPage.status.awaiting_invoice': 'Awaiting invoice',
    'portal.minhasCargasPage.status.awaiting_unload': 'Awaiting unloading',
    'portal.minhasCargasPage.status.unloading': 'Unloading',
    'portal.minhasCargasPage.status.released': 'Released',
    'portal.minhasCargasPage.status.cancelled': 'Cancelled',
  },
  es: {
    'portal.minhasCargasPage.load': 'Carga',
    'portal.minhasCargasPage.contract': 'Contrato',
    'portal.minhasCargasPage.destination': 'Destino',
    'portal.minhasCargasPage.date': 'Fecha',
    'portal.minhasCargasPage.start': 'Inicio',
    'portal.minhasCargasPage.estimatedArrival': 'Llegada prevista',
    'portal.minhasCargasPage.progress': 'Progreso',
    'portal.minhasCargasPage.title': 'Mis cargas',
    'portal.minhasCargasPage.eyebrow': 'Portal del cliente',
    'portal.minhasCargasPage.subtitle': 'Siga el progreso de cada carga de su operación.',
    'portal.minhasCargasPage.list': 'Lista',
    'portal.minhasCargasPage.loadFailed': 'No se pudo cargar.',
    'portal.minhasCargasPage.empty': 'Aún no hay cargas. Sus cargas aparecen cuando envía una solicitud.',
    'portal.minhasCargasPage.kanban': 'Kanban',
    'portal.minhasCargasPage.status.draft': 'Borrador',
    'portal.minhasCargasPage.status.awaiting_harvest': 'Esperando cosecha',
    'portal.minhasCargasPage.status.loading': 'Cargando',
    'portal.minhasCargasPage.status.awaiting_invoice': 'Esperando factura',
    'portal.minhasCargasPage.status.awaiting_unload': 'Esperando descarga',
    'portal.minhasCargasPage.status.unloading': 'En descarga',
    'portal.minhasCargasPage.status.released': 'Liberada',
    'portal.minhasCargasPage.status.cancelled': 'Cancelada',
  },
}
